import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Resource } from '../../beamline-catalog/resource/resources';
import { RelatedLinkBase } from '../../navigation-links/link/related-link-base';

@Component({
  selector: 'sce-list-main',
  templateUrl: './sce-list-main.component.html',
  styleUrls: ['./sce-list-main.component.scss']
})
export class SceListMainComponent extends BaseComponent {

  @Input() resources?: Resource[] | null;
  @Input() resource?: Resource;


  scrollTo(r: Resource) {
    const elem = r.id.toString();
    const divElement = document.getElementById(elem);
    if (divElement)
      divElement.scrollIntoView({ behavior: 'smooth' });
  }
}